import { render, staticRenderFns } from "./FlexModV2.vue?vue&type=template&id=815c5692"
import script from "./FlexModV2.vue?vue&type=script&lang=js"
export * from "./FlexModV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports